import { StackedCheckBox } from "./StackedCheckBox";
import { Label } from "./StackedCheckBox.styled";

const StackedCheckBoxWrapper = Object.assign(StackedCheckBox, {
  Label,
});

export { StackedCheckBoxWrapper as StackedCheckBox };
